module.exports = __webpack_public_path__ + "img/查询专区.aec3c1a1.png";